import * as Notify from "./proto_notify";
import NetMsgDataToBuffer from "../../../../framework/net/net_msgdata_to_buffer";

export class NetMsgDataMapNotify extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服 4为运营后台推送服
    static CommonMessage: any[] = [1, Notify.Notify.CMD_CommonMessage, 1, Notify.Notify.RSP_CommonMessage, 4]
}